"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const $ = require("jquery");
const initTilesCarousel = () => {
    const tilesCarousels = $('[id*="tiles-carousel"]');
    tilesCarousels.each(function () {
        const carousel = $(this);
        let sliderEnabled = false;
        const checkSliderEnabled = () => {
            const windowWidth = $(window).width();
            sliderEnabled = windowWidth !== undefined && windowWidth <= 575;
            if (sliderEnabled) {
                if (!carousel.hasClass('slick-initialized')) {
                    const options = {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true,
                        arrows: false,
                        infinite: true,
                    };
                    carousel.slick(options);
                }
            }
            else {
                if (carousel.hasClass('slick-initialized')) {
                    carousel.slick('unslick');
                }
            }
        };
        $(window).on('resize', checkSliderEnabled);
        checkSliderEnabled();
    });
};
$(document).ready(() => {
    initTilesCarousel();
});
